import React, { useState } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { CartProvider } from "../context/CartContext";

// Componentes
import Nav from "./Nav";
import NavMenu from "./NavMenu";
import Cart from "./Cart";
import BannerPromo from "./BannerPromo";
import ItemListContainer from "../components/ItemListContainer";
import ItemDetailContent from "./ItemDetailContent";
import Home from "./Home";
import Show from "./Show"; // Gestión de Productos
import Ventas from "./Ventas"; // Gestión de Ventas (Nuevo)
import Login from "./Login";
import DetailPromo from "./DetailPromo";

const Main = () => {
  const location = useLocation().pathname;
  const [showCart, setShowCart] = useState(false);
  const [isAdminAuth, setIsAdminAuth] = useState(
    localStorage.getItem("isAdmin") === "true",
  );

  const handleCartModal = () => setShowCart(!showCart);
  const onLoginChange = (status) => setIsAdminAuth(status);

  // Verificamos si estamos en cualquier ruta de admin
  const isAnyAdminRoute = location.startsWith("/admin");

  return (
    <CartProvider>
      {/* Interfaz de Cliente: Solo si NO es admin */}
      {!isAnyAdminRoute && (
        <>
          <Nav handleCartModal={handleCartModal} />
          <NavMenu />
          <Cart show={showCart} handleModal={handleCartModal} />
        </>
      )}

      <div className="container-fluid sinBorde">
        <Routes>
          {/* RUTAS PÚBLICAS */}
          <Route path="/" element={<Home />} />
          <Route path="/promo" element={<DetailPromo />} />
          <Route
            path="/categoria/:nombreCategoria/"
            element={<ItemListContainer />}
          />
          <Route
            path="/detalle/:idProducto/"
            element={<ItemDetailContent handleCartModal={handleCartModal} />}
          />

          {/* RUTAS ADMIN (Protegidas) */}
          <Route
            path="/admin"
            element={
              isAdminAuth ? (
                <Show onLogout={() => onLoginChange(false)} />
              ) : (
                <Login onLoginSuccess={() => onLoginChange(true)} />
              )
            }
          />
          <Route
            path="/admin/ventas"
            element={isAdminAuth ? <Ventas /> : <Navigate to="/admin" />}
          />
        </Routes>
      </div>

      {!isAnyAdminRoute && <BannerPromo handleCartModal={handleCartModal} />}
    </CartProvider>
  );
};

export default Main;
